import { TypeClass } from '../enums';

export const TypeClasses = [
  { name: 'Disease Category', value: TypeClass.Disease },
  { name: 'Support Type', value: TypeClass.Support },
  { name: 'Insurance Type', value: TypeClass.Insurance },
];


